import React from 'react'
import style from './projectColumn.module.scss'
import { useDrop } from 'react-dnd'
import { IEmployee, IProjectToEmployeeLink, IProject } from '../../starter/model/interfaces'
import CardEmployee from '../CardEmployee/CardEmployee'
import CardProject from '../CardProject/CardProject'
import { useAppSelector } from '../../starter/hooks/redux'
import { useUpdateSequenceProjectMutation } from '../../starter/api/sequenceProjectApi'
import dayjs from 'dayjs'

type TProjectColumn = {
  project: IProject
  ProjectToEmployeeLinks: IProjectToEmployeeLink[]
  setLink: (link: IProjectToEmployeeLink) => void
  index: number
  isForgotten?: boolean
}
export default function ProjectColumn({
  project,
  ProjectToEmployeeLinks,
  setLink,
  index,
  isForgotten
}: TProjectColumn) {
  const [UpdateSequence] = useUpdateSequenceProjectMutation()
  const { sequenceProject: sortedProjectTemplate } = useAppSelector((state) => state.sequenceProject)
  const { employees: allEmployees } = useAppSelector((state) => state.employees)

  const [{ isActive: isActiveEmployeeDrop }, projectLinkRef] = useDrop({
    accept: 'employee-small',
    drop(item: IProjectToEmployeeLink | IEmployee) {
      if (item.hasOwnProperty('project') && item.hasOwnProperty('periods')) {
        setLink(item as IProjectToEmployeeLink)
      } else {
        setLink({
          _id: '',
          employee: item as IEmployee,
          project: project,
          periods: []
        })
      }
    },
    collect: (monitor) => ({
      isActive: monitor.canDrop() && monitor.isOver()
    })
  })
  const [{ isActive: isActiveProjectDrop }, projectRef] = useDrop({
    accept: ['project', 'project-small'],
    drop(item: IProject, monitor) {
      const _sortedProjectTemplate = [...sortedProjectTemplate]
      const curIndex = _sortedProjectTemplate.findIndex((f) => f === item._id)
      if (curIndex + 1) {
        _sortedProjectTemplate.splice(curIndex, 1)
        _sortedProjectTemplate.splice(index, 0, item._id)
      } else {
        _sortedProjectTemplate.splice(index, 0, item._id)
      }
      UpdateSequence(_sortedProjectTemplate)
    },
    collect: (monitor) => ({
      isActive: monitor.canDrop() && monitor.isOver(),
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true })
    })
  })

  const dropStyle = {
    background: 'rgba(196,196,196,0.15)'
  }
  return (
    <div
      ref={projectRef}
      className={[style.wrapper, isForgotten ? style.isForgotten : ''].join(' ')}
      style={isActiveEmployeeDrop || isActiveProjectDrop ? dropStyle : {}}>
      <div className={style.projectCard}>
        <CardProject key={project._id} project={project} isSmall={false} />
      </div>
      <div
        className={style.employeeWrapper}
        ref={projectLinkRef}
        style={{
          gridTemplateRows: `repeat(${allEmployees && allEmployees.length}, 1fr)`
        }}>
        {ProjectToEmployeeLinks.filter((linkItem) => {
          let res = false
          const currentPeriod = linkItem.periods.find(
            (p) => dayjs(p.startTime) <= dayjs() && dayjs() <= dayjs(p.endTime)
          )
          if (currentPeriod) {
            res = true
          }
          if (!currentPeriod) {
            linkItem.periods.forEach((period) => {
              if (!period.isHidden) {
                res = true
              }
            })
          }
          return res
        }).map((linkItem, index) => {
          const stylePosition = {
            gridRowStart: allEmployees && allEmployees.findIndex((empl) => empl._id === linkItem.employee._id) + 1,
            display: 'flex',
            justifyContent: 'center'
          }
          return (
            <div key={linkItem._id} className={style.cell} style={stylePosition}>
              <CardEmployee linkItem={linkItem} isSmall={false} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
